import { action, observable, runInAction } from 'mobx';
import { StringStore } from 'ui/base/input';
import { AvatarStore } from 'ui/standard/input/avatar_input/avatar_store';
import { CountryStore } from 'ui/standard/input/country_input/country_store';
import { AvatarCode, IAccountsDomain } from 'services/accounts/types';
import * as UserService from 'services/accounts/user_service';
import { ResultKind } from 'services/base/types';
import { BusyStore } from 'ui/base/button';

export class EditSettingsStore {
  readonly email: StringStore;
  readonly country: CountryStore;
  readonly mobileNumber: StringStore;
  avatar: AvatarStore;

  @observable.ref
  emailError: string | undefined;

  @observable.ref
  passwordError: string | undefined;

  @observable.ref
  countryError: string | undefined;

  @observable.ref
  mobileNumberError: string | undefined;

  @observable.ref
  busy: BusyStore;

  constructor({
    email,
    country,
    mobileNumber,
    mobileNumberPrefix,
    avatarCode,
  }: {
    email: string;
    country: string;
    mobileNumber: string;
    mobileNumberPrefix: string;
    avatarCode: AvatarCode;
  }) {
    this.email = new StringStore(email);
    this.country = new CountryStore(country, mobileNumberPrefix);
    this.mobileNumber = new StringStore(mobileNumber);
    this.avatar = new AvatarStore(avatarCode);
    this.busy = new BusyStore();
  }

  @action.bound
  async handleEditSettings(domain: IAccountsDomain): Promise<UserService.PatchResult> {
    const result = await UserService.patch({
      domain,
      email: this.email.value,
      country: this.country.country.value,
      mobileNumberPrefix: this.country.prefix.value,
      mobileNumber: this.mobileNumber.value,
      avatarCode: this.avatar.value,
    });
    runInAction(() => {
      if (result.kind === ResultKind.USER_ERROR) {
        this.emailError = result.emailError;
        this.countryError = result.countryError;
        this.mobileNumberError = result.mobileNumberError;
      }
    });
    return result;
  }
}
